module.exports = __webpack_public_path__ + "img/install_theme_icon_1.3209ffdc.png";